/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_cp_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`More frequent compounding (e.g. monthly vs annually) earns slightly more, because interest is added to the balance more often and then itself earns interest.`)
};

const es_cp_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La capitalización más frecuente (p. ej. mensual vs anual) gana ligeramente más, porque el interés se añade al saldo más frecuentemente y luego ese interés gana interés.`)
};

const de_cp_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Häufigere Verzinsung (z. B. monatlich statt jährlich) erwirtschaftet etwas mehr, da die Zinsen häufiger dem Saldo hinzugefügt werden und dann selbst wieder Zinsen erhalten.`)
};

const nl_cp_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Frequentere renteverrekening (bijv. maandelijks in plaats van jaarlijks) levert iets meer op, omdat rente vaker bij het saldo wordt opgeteld en vervolgens zelf rente oplevert.`)
};

const fr_cp_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Une composition plus fréquente (par exemple, mensuelle par rapport à annuellement) gagne légèrement plus, car les intérêts sont ajoutés au solde plus souvent et gagnent ensuite eux-mêmes des intérêts.`)
};

const it_cp_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La capitalizzazione più frequente (ad es. mensile vs annuale) guadagna leggermente di più, perché l'interesse viene aggiunto al saldo più spesso e quindi guadagna interessi.`)
};

const pt_br2_cp_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A capitalização mais frequente (p.ex. mensal vs anual) rende um pouco mais, pois os juros são adicionados ao saldo com mais frequência e depois rendem juros por si.`)
};

const pt_cp_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A capitalização mais frequente (p. ex. mensalmente vs anualmente) ganha ligeiramente mais, porque o juro é adicionado ao saldo com mais frequência e depois ganha juro por si só.`)
};

const ja_cp_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`より頻繁な複利計算（例：毎月対年1回）はわずかに多く獲得します。なぜなら、利息がより頻繁に残高に加算され、その後それ自体が利息を獲得するからです。`)
};

const zh_cp_faq1_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`更频繁的复利（例如按月而非按年）会带来略高的收益，因为利息会更频繁地计入余额，然后本身也会产生利息。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const cp_faq1_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.cp_faq1_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("cp_faq1_a", locale)
	if (locale === "en") return en_cp_faq1_a(inputs)
	if (locale === "es") return es_cp_faq1_a(inputs)
	if (locale === "de") return de_cp_faq1_a(inputs)
	if (locale === "nl") return nl_cp_faq1_a(inputs)
	if (locale === "fr") return fr_cp_faq1_a(inputs)
	if (locale === "it") return it_cp_faq1_a(inputs)
	if (locale === "pt-BR") return pt_br2_cp_faq1_a(inputs)
	if (locale === "pt") return pt_cp_faq1_a(inputs)
	if (locale === "ja") return ja_cp_faq1_a(inputs)
	return zh_cp_faq1_a(inputs)
};